export default __webpack_public_path__ + "static/media/retail-buyers-assistant-for-product-sourcing.54075464.png";